import { observable, action } from "mobx"

/**
* Event defines model for prelive event
* @typedef Event
* @type {Object}
* @property {eventStartingDate} Event starting date
* @property {eventStartingTime} Event starting time
* @property {id} Event unique id
* @property {sortId} Event sorting coefficient
* @property {personalizedSortId} Event additional sorting id, coming from Personalization API if the event is flagged 'for you'
* @property {sportId} ID of the Event`s sport
* @property {leagueId} ID of the Event`s league
* @property {marketIds} Event`s markets IDs stored in an array
* @property {sportName} Name of the Event`s sport
* @property {leagueName} Name of the Event`s league
* @property {eventName} Name of the Event
* @property {linkAddress} Link of the event card
* @property {participant1Name} Name of the home player in event
* @property {participant2Name} Name of the away player in event
* @property {isGoingLive} Flag informing whether the event is in kick-off state
* @property {isTeamSwapEnabled} Flag informing whether the event has option TeamSwapping set 'on'
* @property {totalMarketsCount} Number of all the markets related to the event
* @property {hasStatistics} Flag informing whether the event has statistics available
* @property {hasLiveStream} Flag informing whether the event has live streaming available
* @property {statisticsInfo} Structured information needed to show event`s statistics
*/

export type EventType =
{
    eventStartingDate: string;
    eventStartingTime: string;
    eventDate: string;

    id: string;
    sortId: string;
    personalizedSortId: string;
    sportId: string;
    leagueId: string;
    sportSortId: string;

    marketIds: string[];

    sportName: string;
    leagueName: string;
    eventName: string;

    linkAddress: string;

    participant1Name: string;
    participant2Name: string;

    isTeamSwapEnabled: boolean;
    totalMarketsCount: number;
}

export class Event
{
    @observable eventStartingDate: string;
    @observable eventStartingTime: string;
    @observable eventDate: string;

    id: string;
    sortId: string;
    personalizedSortId: string;
    sportId: string;
    leagueId: string;
    sportSortId: string;

    @observable marketIds: string[];

    sportName: string;
    leagueName: string;
    eventName: string;

    linkAddress: string;

    participant1Name: string;
    participant2Name: string;

    isTeamSwapEnabled: boolean;
    @observable totalMarketsCount: number;

    constructor(event: EventType)
    {
        this.eventStartingDate = event.eventStartingDate;
        this.eventStartingTime = event.eventStartingTime;
        this.eventDate = event.eventDate;

        this.id = event.id;
        this.sortId = event.sortId;
        this.personalizedSortId = event. personalizedSortId;
        this.sportId = event.sportId;
        this.sportSortId = event.sportSortId;
        this.marketIds = event.marketIds;
        this.leagueId = event.leagueId;

        this.sportName = event.sportName;
        this.leagueName = event.leagueName;
        this.eventName = event.eventName;

        this.linkAddress = event.linkAddress;

        this.participant1Name = event.participant1Name;
        this.participant2Name = event.participant2Name;

        this.isTeamSwapEnabled = event.isTeamSwapEnabled;
        this.totalMarketsCount = event.totalMarketsCount;

    }

    @action updateDateTime( newEventDate: string, newEventTime: string, eventDate: string )
    {
        this.eventDate = eventDate;
        this.eventStartingTime = newEventTime;
        this.eventStartingDate = newEventDate;
    }

    @action updateMarkets( newMarkets: string[], newMarketsCount: number )
    {
        this.marketIds = newMarkets;
        this.totalMarketsCount = newMarketsCount;
    }

}
